export enum BannerShape {
  ORIGINAL = 1,
  ONE_PIECE = 2,
  TWO_PIECES = 3,
  THREE_PIECES = 4,
  CIRCLES = 5,
}

export const getShapeColor = (status: BannerShape) => {
  switch (status) {
    case BannerShape.ORIGINAL:
      return "green";
    case BannerShape.ONE_PIECE:
      return "orange";
    case BannerShape.TWO_PIECES:
      return "blue";
    case BannerShape.THREE_PIECES:
      return "green";
    case BannerShape.CIRCLES:
      return "red";
  }
};

// Status Boolean stuts
export const getShape = (status: BannerShape) => {
  switch (status) {
    case BannerShape.ORIGINAL:
      return "original";
    case BannerShape.ONE_PIECE:
      return "one_piece";
    case BannerShape.TWO_PIECES:
      return "two_piece";
    case BannerShape.THREE_PIECES:
      return "three_piece";
    case BannerShape.CIRCLES:
      return "circles";
    default:
      return "default";
  }
};


export enum SectionStatus {
  ACTIVE = 1,
  INACTIVE = 2,
}

export const getSectionStatusColor = (status: SectionStatus) => {
  switch (status) {
    case SectionStatus.ACTIVE:
      return "green";
    case SectionStatus.INACTIVE:
      return "red";
    default:
      return "red";
  }
};

export const getSectionStatus = (status: SectionStatus) => {
  switch (status) {
    case SectionStatus.ACTIVE:
      return "active";
    case SectionStatus.INACTIVE:
      return "inactive";
    default:
      return "inactive";
  }
};
